<template>
  <div>
    <el-form
      :model="formData"
      :rules="rules"
      ref="form"
      class="main-form-scroll"
    >
      <el-form-item :label="$t('user.login')" prop="loginSelected">
        <el-input v-model="formData.loginSelected"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.password')" prop="password">
        <el-input v-model="formData.password" show-password></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.fullName')" prop="fullNameSelected">
        <el-input v-model="formData.fullNameSelected"></el-input>
      </el-form-item>
      <el-form-item
        v-show="type === 'edit'"
        :label="$t('user.expirationDate')"
        prop="dateEndSelected"
      >
        <el-date-picker
          v-model="formData.dateEndSelected"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        :label="$t('user.role')"
        v-show="getUser.userid === '0' || getUser.userid === '1'"
        prop="idRole"
      >
        <el-select v-model="formData.idRole" filterable>
          <el-option
            v-for="(role, index) in getRolesTableArray"
            :key="index"
            :label="role.name"
            :value="role.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="disableChecked">
        <el-checkbox v-model="formData.disableChecked"
          >{{ $t('user.blockUser') }}</el-checkbox
        >
      </el-form-item>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick"
          >{{ $t('user.cancel') }}</el-button
        >
        <el-button
          class="button-confirm"
          type="success"
          @click="okClick"
          >OK</el-button
        >
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      formData: {
        loginSelected: null,
        fullNameSelected: null,
        dateEndSelected: null,
        disableChecked: false,
        password: null,
        idRole: null,
      },
      rules: {
        loginSelected: [
          {
            required: true,
            message: this.$t('user.enterUserLogin'),
            trigger: "blur",
          },
        ],
        fullNameSelected: [
          {
            required: true,
            message: this.$t('user.enterUserFullName'),
            trigger: "blur",
          },
        ],
        dateEndSelected: [
          {
            //нужна при редактировании, но не при создании
            required: this.type === "edit" ? true : false,
            message: this.$t('user.enterEndDate'),
            trigger: "change",
          },
        ],
        disableChecked: [{ required: false }],
        password: [
          {
            //обязателен при создании пользователя, но не обязателен при редактировании
            required: this.type === "edit" ? false : true,
            message: this.$t('user.enterPassword'),
            trigger: "blur",
          },
        ],
        idRole: [
          {
            required: true,
            message: this.$t('user.enterRole'),
            trigger: "change",
          },
        ],
      },
    };
  },
  props: {
    type: String,
  },
  methods: {
    populateForm() {
      this.formData.loginSelected = this.getCurInfo.login;
      this.formData.password = null;
      this.formData.fullNameSelected = this.getCurInfo.fullName;
      this.formData.dateEndSelected = this.getCurInfo.dateend;
      this.formData.idRole = this.getCurInfo.idRole;
      this.formData.disableChecked =
        this.getCurInfo.disable === "0" ? false : true;
    },
    okClick() {
      for (let index in this.formData) {
        if (
          this.formData[index] != null &&
          typeof this.formData[index] === "string"
        ) {
          this.formData[index] = this.formData[index].trim();
        }
      }
      this.$refs["form"].validate((valid, object) => {
        if (valid) {
          this.$emit("data", this.formData);
        } else {
          this.$message.error(this.$t('errors.notAllRequiredFieldsSelected'));
        }
      });
    },
    cancelClick() {
      this.$emit("close");
    },
  },
  created() {
    if (this.type === "edit") {
      this.populateForm();
    }
  },
  computed: {
    ...mapGetters(["getCurInfo", "getRolesTableArray", "getUser"]),
  },
};
</script>


<style scoped>
</style>